var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Hero',[_c('strong',[_vm._v("\n      Работайте с лучшими,\n    ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('em',[_vm._v("\n      в лучших условиях\n    ")])]),_vm._v(" "),_c('TeamOffer'),_vm._v(" "),_c('TeamCulture'),_vm._v(" "),_c('TeamVideos'),_vm._v(" "),_c('TeamTeam')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33a4da26","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Team.vue
// module id = null
// module chunks = 